import React, {memo, useState} from "react";
import Form from "./form";
import {Table, Pagination, Button} from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';

function DataTable({response, setPage, change, setChange, deleteItem}) {
    const [show, setShow] = useState(false);
    const [site, setSite] = useState();

    const editItem = async (siteId) => {
        await axios.get(`${process.env.REACT_APP_API_URL}/site/${siteId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    setSite(response.data.data);
                    setShow(true);
                } else {
                    console.log(response);
                }
            });
    }

    return (
        <>
            <div className="bg-white rounded border mb-3">
                <Table hover responsive className="mb-0">
                    <thead>
                    <tr>
                        <th>Site Adı</th>
                        <th>Site URL</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>

                    {response.data && (response.data).map((element) => (
                        <tr key={element.siteId}>
                            <td>{element.siteName}</td>
                            <td>{element.siteUrl}</td>

                            <td className="text-end">

                                <Button variant="dark" className="py-0 px-2 me-2"
                                        onClick={() => editItem(element.siteId)}>Düzenle</Button>

                                <Button variant="danger" className="py-0 px-2" onClick={() =>
                                    Swal.fire({
                                        html: `<strong>${element.siteName}</strong> sitesini silmek istiyor musun?`,
                                        icon: "question",
                                        confirmButtonText: "Evet",
                                        showCancelButton: true,
                                        cancelButtonText: "Hayır",
                                        allowEnterKey: false,
                                        preConfirm: () => {
                                            deleteItem(element.siteId);
                                        }
                                    })
                                }>Sil</Button>
                            </td>
                        </tr>
                    ))}

                    </tbody>
                </Table>
            </div>
            <Pagination>
                {Array.from({length: response.pageCount}, (item, index) =>
                    <Pagination.Item key={index} onClick={(page) => setPage(index + 1)}
                                     active={response.page === index}>{(index + 1)}</Pagination.Item>
                )}
            </Pagination>

            {show &&
                <Form change={change} setChange={setChange} show={show} setShow={setShow} site={site}/>}
        </>
    )

}

export default memo(DataTable);
